// Drawer opener controller
// Opens a drawer that lives outside the current Stimulus scope (e.g. a trigger
// button in the sticky header that needs to open a drawer rendered in the body).
//
// Usage:
//   <button data-controller="ui--drawer-opener"
//           data-ui--drawer-opener-drawer-id-value="my-drawer"
//           data-action="click->ui--drawer-opener#open">
//     Open
//   </button>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { drawerId: String }

  open() {
    const drawerEl = document.getElementById(this.drawerIdValue)
    if (!drawerEl) return

    // If this trigger sits inside another drawer, that drawer is the parent of
    // the one being opened. Recording it lets the parent slide aside for its own
    // child only — a numeric stack level alone would also match any unrelated
    // drawer that happened to be assigned a lower one. CONEK-6530.
    const parent = this.element.closest('[data-controller~="ui--drawer"]')
    if (parent?.id) {
      drawerEl.dataset.openedFrom = parent.id
    } else {
      delete drawerEl.dataset.openedFrom
    }

    const controller = this.application.getControllerForElementAndIdentifier(
      drawerEl,
      "ui--drawer",
    )
    controller?.show()
  }
}
